import { render, staticRenderFns } from "./StagingEditorSideBar.vue?vue&type=template&id=d22b12ba"
import script from "./StagingEditorSideBar.vue?vue&type=script&lang=ts"
export * from "./StagingEditorSideBar.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorSideBar.vue?vue&type=style&index=0&id=d22b12ba&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports